import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcecontrolSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { accountingperiod } from '../../../../icemedx-lib/src/models/accounting/accountingperiod';
import { accountingperiodindex } from '../../../../icemedx-lib/src/models/accounting/accountingperoidindex';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { AppService } from '../app.service';

@Component({
  selector: 'accountingperiod',
  templateUrl: './accountingperiod.component.html',
  styleUrls: ['./accountingperiod.component.scss'],
  providers: [AppService, IcepanelComponent, IcepanelContainerComponent]
})
export class AccountingperiodComponent implements OnInit {
  @Input() hide: boolean = false;
  @Input() disablePeriod: boolean = false;
  @Output() periodActionRequired: EventEmitter<any> = new EventEmitter<any>();
  @Output() periodChange: EventEmitter<any> = new EventEmitter<any>();
  editedAccountingPeriod: accountingperiod = null;
  currentAccountingPeriod: accountingperiod = null;
  allPeriods: accountingperiod[] = null;

  // Periods
  periods: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "currentPeriod", "Select Period")
    .setControlName("currentPeriod")
    .createFormControl("", [])
    .setOptions([
      { name: "<Undefined Accounting Period>", value: "" }
    ]);

  createPeriodButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Create Accounting Period", glyphClass: "fas fa-plus-circle", width: "100px" }, null, null, "createPeriod");
  editPeriodButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Edit Period", glyphClass: "fas fa-edit", width: "50px" }, null, null, "editPeriod");
  periodTitle: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, "periodTitle", "Title of Period")
    .setControlName("periodTitle")
    .createFormControl("", []);
  periodFrom: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", width: "125px" }, null, null, "periodFromDate")
    .setControlName("periodFrom")
    .createFormControl(null, []);
  periodTo: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", width: "125px" }, null, null, "periodToDate")
    .setControlName("periodTo")
    .createFormControl(null, []);
  periodBasis: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "periodBasis", "Accounting Basis")
    .setControlName("periodBasis")
    .createFormControl(IceTypes.basis_of_accounting.boaCash, [])
    .setOptions([
      { name: "Cash", value: IceTypes.basis_of_accounting.boaCash },
      { name: "Accrual", value: IceTypes.basis_of_accounting.boaAccrual }])
    .setDisabled(true);

  periodStatus: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "periodStatus", "Status of Period")
    .setControlName("periodStatus")
    .createFormControl(IceTypes.period_status.psCreated, [])
    .setOptions([
      { name: "Open", value: IceTypes.period_status.psCreated },
      { name: "Started", value: IceTypes.period_status.psStarted },
      { name: "Paused", value: IceTypes.period_status.psPaused },
      { name: "Closed", value: IceTypes.period_status.psFinished }
    ]);
  cancelPeriod: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Cancel", glyphClass: "fas fa-times", width: "50px" }, null, null, "cancelPeriod");
  submitPeriod: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Submit", glyphClass: "fas fa-check", width: "50px" }, null, null, "submitPeriod");

  constructor(private appSvc: AppService, private acctSvc: AccountingService) {
  }

  ngOnInit() {
    this.acctSvc.getPeriods(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let opts = this.periods.getOptions();
          for (let i = 0; i < data.length; i++) {
            let actper: accountingperiodindex = <accountingperiodindex>data[i];

            let periodDesc = AccountingService.getPeriodDesc(actper, AccountingService.getPeriodStatus(<IceTypes.period_status>Iceutility.toLong(actper.status)));
            opts.push({ value: actper.accounting_period_key, name: periodDesc });
          }
          this.periods.setOptions(opts);
          this.allPeriods = data;
          this.updateCurrentPeriodOption();
          this.periods.setDisabled(this.disablePeriod);
        }
        else {
          this.notifyPeriodRequirement("NoCurrentPeriod", null);
        }
      },
      error => {
        this.notifyPeriodRequirement("NoCurrentPeriod", null);
      }
    );
  }

  getPeriods(): number {
    return this.periods.getOptions().length;
  }

  periodSelected(): boolean {
    let val = this.periods.getFormControl().value;
    return val != null && val.length > 0;
  }

  disableCreatePeriod(): boolean {
    return this.disablePeriod; // To do add permissions
  }

  disableEditPeriod(): boolean {
    return this.disablePeriod; // To do add permissions
  }

  updateCurrentPeriodOption(): void {
    this.acctSvc.getCurrentPeriod(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType()).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let currentActPer: accountingperiodindex = <accountingperiodindex>data[0];
          let statusDesc = AccountingService.getPeriodStatus(<IceTypes.period_status>Iceutility.toLong(currentActPer.status));
          switch (Iceutility.toLong(currentActPer.status)) {
            case IceTypes.period_status.psCreated:
            case IceTypes.period_status.psStarted:
              statusDesc = "Started";
              break;
          }

          let periodDesc = AccountingService.getPeriodDesc(currentActPer, ["Current", statusDesc].join(","));

          // Set DDL
          let foundOpts = this.periods.getOptions().filter(a => a.value == currentActPer.accounting_period_key);
          if (foundOpts.length > 0) {
            foundOpts[0].name = periodDesc;
          }
          else {
            this.periods.getOptions().push({ value: currentActPer.accounting_period_key, name: periodDesc });
          }
          this.periods.getFormControl().setValue(currentActPer.accounting_period_key);

          this.currentAccountingPeriod = new accountingperiod(currentActPer);

          let matEvent: MatSelectChange = new MatSelectChange(null, currentActPer.accounting_period_key);
          matEvent["selectSettings"] = this.periods;
          this.periodChange.emit(matEvent);
        }
        else {
          this.hide = false;
          this.disablePeriod = false;
          this.notifyPeriodRequirement("NoCurrentPeriod", null);
        }
      },
      error => {
        this.hide = false;
        this.disablePeriod = false;
        this.notifyPeriodRequirement("NoCurrentPeriod", null);
        console.log(JSON.stringify(this.acctSvc.getLastErrors()));
      }
    );
  }

  notifyPeriodRequirement(key: string, opt: any) {
    let matEvent: MatSelectChange = new MatSelectChange(null, key);
    matEvent["selectSettings"] = this.periods;
    matEvent["selected"] = opt;
    this.periodActionRequired.emit(matEvent);
  }

  /////////////////////////////
  // Events
  periodSelectChange(event): void {
    this.periodChange.emit(event);
  }

  createPeriodClick(event): void {
    this.periods.setDisabled(true);
    this.editedAccountingPeriod = new accountingperiod();
    this.editedAccountingPeriod.title = "Untitled";
    this.editedAccountingPeriod.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;

    let opts = this.periodStatus.getOptions();
    let removeStatuses = opts.filter(s => s.value != IceTypes.period_status.psPaused && s.value != IceTypes.period_status.psFinished);
    this.periodStatus.setOptions(removeStatuses);
    let started = removeStatuses.filter(s => s.value == IceTypes.period_status.psStarted);
    if (started.length > 0) {
      started[0].name = this.currentAccountingPeriod == null ? "Start Period Now" : "Open";
    }
    this.periodTitle.getFormControl().setValue(this.editedAccountingPeriod.title);
    this.periodFrom.getFormControl().setValue(Iceutility.GetLocalDate());
    this.periodTo.getFormControl().setValue(NaN);
    this.periodBasis.getFormControl().setValue(IceTypes.basis_of_accounting.boaCash);
    this.periodStatus.getFormControl().setValue(this.currentAccountingPeriod == null ? IceTypes.period_status.psStarted : IceTypes.period_status.psCreated);
    this.periodBasis.setDisabled(false);
  }

  editPeriodClick(event): void {
    let val = this.periods.getFormControl().value;
    if (val != null && val.length > 0) {
      this.acctSvc.getPeriod(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), val).subscribe(
        data => {
          if (data != null && data.length > 0) {
            this.periods.setDisabled(true);
            this.editedAccountingPeriod = <accountingperiodindex>data[0];
            this.editedAccountingPeriod.offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
            this.periodTitle.getFormControl().setValue(this.editedAccountingPeriod.title);
            this.periodFrom.getFormControl().setValue(Iceutility.isTextDateTime(this.editedAccountingPeriod.start_date) ? Iceutility.GetLocalDate(this.editedAccountingPeriod.start_date) : Iceutility.ConvertFromDotNetServerTime(this.editedAccountingPeriod.start_date));
            this.periodTo.getFormControl().setValue(Iceutility.isTextDateTime(this.editedAccountingPeriod.end_date) ? Iceutility.GetLocalDate(this.editedAccountingPeriod.end_date) : Iceutility.ConvertFromDotNetServerTime(this.editedAccountingPeriod.end_date));
            this.periodBasis.getFormControl().setValue(<IceTypes.basis_of_accounting>Iceutility.toLong(this.editedAccountingPeriod.basis));

            this.periodStatus.setOptions([]);
            switch (Iceutility.toLong(this.editedAccountingPeriod.status)) {
              case IceTypes.period_status.psCreated:
                this.periodStatus.setOptions([
                  { name: "Open", value: IceTypes.period_status.psCreated },
                  { name: "Start", value: IceTypes.period_status.psStarted },
                  { name: "Close", value: IceTypes.period_status.psFinished }
                ]);
                break;
              case IceTypes.period_status.psStarted:
                this.periodStatus.setOptions([
                  { name: "Start", value: IceTypes.period_status.psStarted },
                  { name: "Pause", value: IceTypes.period_status.psPaused },
                  { name: "Close", value: IceTypes.period_status.psFinished }
                ]);
                break;
              case IceTypes.period_status.psPaused:
                this.periodStatus.setOptions([
                  { name: "Start", value: IceTypes.period_status.psStarted },
                  { name: "Pause", value: IceTypes.period_status.psPaused },
                ]);
                break;
              case IceTypes.period_status.psFinished:
                this.periodStatus.setOptions([
                  { name: "Open", value: IceTypes.period_status.psCreated },
                  { name: "Close", value: IceTypes.period_status.psFinished }
                ]);
                break;
            }
            this.periodStatus.getFormControl().setValue(<IceTypes.period_status>Iceutility.toLong(this.editedAccountingPeriod.status));
          }
        },
        error => {
        }
      );

      //let foundPer = this.allPeriods.filter(a => a.accounting_period_key == val);
      //if (foundPer.length > 0) {
      //}
    }
  }

  periodBasisSelectChange(event): void {
  }

  periodStatusSelectChange(event): void {
  }

  cancelPeriodClick(event): void {
    this.periods.setDisabled(false);
    this.editedAccountingPeriod = null;
    this.periodTitle.getFormControl().setValue("");
    this.periodFrom.getFormControl().setValue(NaN);
    this.periodTo.getFormControl().setValue(NaN);
    this.periodBasis.getFormControl().setValue(IceTypes.basis_of_accounting.boaCash);
    this.periodStatus.getFormControl().setValue(IceTypes.period_status.psCreated);
  }

  submitPeriodClick(event): void {
    if (this.editedAccountingPeriod == null) return;

    this.editedAccountingPeriod.title = this.periodTitle.getFormControl().value;
    if (this.editedAccountingPeriod.title == null || this.editedAccountingPeriod.title.length == 0) {
      if (false == Iceutility.yesnomodal("Title is required, would you like to create without title?"))
        return;

      this.editedAccountingPeriod.title = "Untitled";
    }

    let fromDt = this.periodFrom.getFormControl().value;
    this.editedAccountingPeriod.start_date = Iceutility.GetDateText(fromDt, null, false);
    this.editedAccountingPeriod.end_date = Iceutility.convertToUTCEx(this.periodTo.getFormControl().value);
    this.editedAccountingPeriod.basis = this.periodBasis.getFormControl().value;
    this.editedAccountingPeriod.status = this.periodStatus.getFormControl().value;
    let currentPeriod = true;
    this.acctSvc.insertUpdatePeriod(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), currentPeriod, this.editedAccountingPeriod).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let recstatus = this.editedAccountingPeriod.offline_record_status;
          this.editedAccountingPeriod = null;
          this.periods.setDisabled(false);
          this.periodBasis.setDisabled(true);

          let notificationKey = "CurrentPeriodChanged";

          let per: accountingperiod = data[0];
          let perOpt = null;
          let periodDesc = AccountingService.getPeriodDesc(per, AccountingService.getPeriodStatus(<IceTypes.period_status>Iceutility.toLong(per.status)));
          if (recstatus == IceTypes.offlineRecStatus.offlineInsert) {
            let opts = this.periods.getOptions();
            perOpt = { value: per.accounting_period_key, name: periodDesc };
            opts.push(perOpt);
            this.periods.setOptions(opts);
            if (this.allPeriods == null)
              this.allPeriods = [];

            this.allPeriods.push(per);
            notificationKey = "NewPeriod";
          }
          else {
            let foundOpts = this.periods.getOptions().filter(a => a.value == per.accounting_period_key);
            if (foundOpts.length > 0) {
              foundOpts[0].name = periodDesc;
              perOpt = foundOpts[0];
            }
          }
          this.updateCurrentPeriodOption();
          this.notifyPeriodRequirement(notificationKey, perOpt);
        }
        else {
        }
      },
      error => {
        console.log(JSON.stringify(this.acctSvc.getLastErrors()));
      });
  }

}
